<template>
  <div class="app">
    <div class="header">
      <Nav :navList="navList" @shopTrue="shopBool = $event" @heartTrue="heartBool = $event" :heart="heart" :shop="shop" :icon="icon" :iconShop="iconShop" @cartList="cartList" @navH="navH=$event"/>
      <TransitionGroup name="cart" mode="out-in">
        <Intro v-if="!cart" class="introOne"/>
      </TransitionGroup>
    </div>
    <div class="container">
      <Cart v-if="cart" :tOne="tOne" @addCart="addCart" @tMinus="tMinus" @delCart="delCart" @tPlus="tPlus" @addHeart="addHeart" @heartFill="heartFill" @cartObj="cartObj" :navH="navH" :OneFilter="OneFilter" @modalBool="modalInfo"/>
    </div>
    <div v-if="!cart" class="container">
      <Katalog :kOne="kOne" :kTwo="kTwo"/>
      <Tavar :tOne="tOne" @addCart="addCart" @tPlus="tPlus" @tMinus="tMinus" @delCart="delCart" @addHeart="addHeart" @heartFill="heartFill" @modalBool="modalInfo"/>
      <Raboti :rOne="rOne" :rTwo="rTwo"/>
    </div>
    <Footer />
    <Shop :shop="shop" :shopBool="shopBool" @shopFalse="shopBool = $event" @changeCart="changeCart" @delCard="delCard"/>
    <Heart :heart="heart" :heartBool="heartBool" @heartFalse="heartBool = $event" @delHeart="delHeart"/>
  </div>
  <TransitionGroup name="modal">
    <Modal v-if="modalBool" :modalObj="modalObj" @modalBool="modalBool = false"/>
  </TransitionGroup>
</template>

<script>
import Nav from "@/components/header/Nav.vue";
import Intro from "@/components/header/Intro.vue";
import Shop from "@/components/header/Shop.vue";
import Heart from "@/components/header/Heart.vue";
import Katalog from "@/components/section/Katalog.vue";
import Tavar from '@/components/section/Tavar.vue';
import Raboti from '@/components/section/Raboti.vue';
import Cart from '@/components/cart/Cart.vue';
import Modal from '@/components/Modal.vue';
import Footer from "@/components/footer/Footer.vue";
export default {
  components:{
    Nav,
    Intro,
    Shop,
    Heart,
    Katalog,
    Tavar,
    Raboti,
    Cart,
    Modal,
    Footer
  },
  data() {
    return {
      modalBool: false,
      modalObj:{},
      OneFilter: '',
      navH:0,
      cart:false,
      shopBool: false,
      heartBool: false,
      shop:[],
      heart:[],
      icon: "",
      iconShop:"",
      navList:[
        {
          list:'Mebel'.toUpperCase(),
          afterBool:true,
          filter:'mebel',
          after:[
            'devanlar',
            'stol stullar',
            'romlar',
            'eshiklar'
          ],
        },
        {
          list:"O'yinchoqlar".toUpperCase(),
          filter:'toys',
        },
        {
          list:'Maishiy Texnika'.toUpperCase(),
          afterBool:true,
          filter:'texnika',
          after:[
            'Televezor',
            'Kir yuvish mashenasi',
            'chang yutgich'
          ]
        },
        {
          list:'Qurilish mollari'.toUpperCase(),
          filter:'qurilish',
        },
        {
          list:'Gadjetlar'.toUpperCase(),
          afterBool:true,
          filter:'gadjet',
          after:[
            'Telefonlar',
            'Noutbooklar',
            'Stol Kamputerlar',
            'naushniklar'
          ]
        },
        {
          list:'Sport anjomlari'.toUpperCase(),
          filter:'sport',
          after:[
            'devanlar',
            'eshiklar',
            'romlar',
            'mebel'
          ]
        },
        {
          list:'Avto Jihozlar'.toUpperCase(),
          filter:'avto',
          after:[
            'devanlar',
            'eshiklar',
            'romlar',
            'mebel'
          ]
        },
        {
          list:'MEHMONXONA'.toUpperCase(),
          filter:'gastnetsa',
          after:[
            'devanlar',
            'eshiklar',
            'romlar',
            'mebel'
          ]
        },
      ],
      kOne:[
        {img:require("@/assets/img/k__location.svg"),title:"Do'konning qulay joylashuvi"},
        {img:require("@/assets/img/k__dastavka.svg"),title:"Tez yetkazib berish"},
        {img:require("@/assets/img/price.svg"),title:"Past narxlar"},
        {img:require("@/assets/img/sifat.svg"),title:"Muddatli to'lov"}
      ],
      kTwo:[
        {img:require("@/assets/img/devan_1.png"),text:"MEBEL"},
        {img:require("@/assets/img/toys-1.jpg"),text:"TOYS"},
        {img:require("@/assets/img/televesion-4.jpg"),text:"TEXNIKA"},
        {img:require("@/assets/img/bosch-1.jpg"),text:"QURULISH MOLLARI"},
        {img:require("@/assets/img/noutbook-5.webp"),text:"GADJET"},
        {img:require("@/assets/img/krasofka.jpg"),text:"SPORT"},
        {img:require("@/assets/img/balon.jpg"),text:"AVTO"},
      ],
      tOne:[
        {filter:'mebel',img:require('@/assets/img/devan_1.png'),title:"Mebel, Devan KRR1600.1",price:6500000, amount: 1, amountBool: true, id:1, heartFill: true},
        {filter:'mebel',img:require('@/assets/img/devan_2.jpg'),title:"Угловой диван-кровать",price:7500000, amount: 1, amountBool: true, id:2, heartFill: true},
        {filter:'mebel',img:require('@/assets/img/devan_3.jpg'),title:"Прямой диван-кровать",price:6000000, amount: 1, amountBool: true, id:3, heartFill: true},
        {filter:'mebel',img:require('@/assets/img/devan_4.jpg'),title:"Диван-кровать",price:6450000, amount: 1, amountBool: true, id:4, heartFill: true},
        {filter:'mebel',img:require('@/assets/img/devan_5.jpg'),title:"Бельгия Green",price:6270000, amount: 1, amountBool: true, id:5, heartFill: true},
        {filter:'mebel',img:require('@/assets/img/stul_1.jpg'),title:"Прямой диван GH-60",price:5270000, amount: 1, amountBool: true, id:6, heartFill: true},
        {filter:'mebel',img:require('@/assets/img/stul_2.jpg'),title:"Прямой диван-кровать «Менли»",price:4074000, amount: 1, amountBool: true, id:7, heartFill: true},
        {filter:'mebel',img:require('@/assets/img/stul_3.jpg'),title:"Угловой диван-кровать «Milan-Orange»",price:7410000, amount: 1, amountBool: true, id:8, heartFill: true},
        {filter:'mebel',img:require('@/assets/img/stul_4.jpg'),title:"London modulli oshxona",price:6175000, amount: 1, amountBool: true, id:9, heartFill: true},
        {filter:'mebel',img:require('@/assets/img/stul_5.jpg'),title:"Уильям White",price:6365000, amount: 1, amountBool: true, id:10, heartFill: true},
        {filter:'mebel',img:require('@/assets/img/stul_6.jpg'),title:"Угловой диван-кровать Monaco-7",price:5700000, amount: 1, amountBool: true, id:11, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-1.jpg'),title:"Brown bear",price:210000, amount: 1, amountBool: true, id:12, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-2.jpg'),title:"Tiger",price:20000, amount: 1, amountBool: true, id:13, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-3.jpg'),title:"Panda",price:120000, amount: 1, amountBool: true, id:14, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-4.jpg'),title:"Pinc Bear",price:10000, amount: 1, amountBool: true, id:15, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-5.jpg'),title:"Ninza tashbaqa",price:380000, amount: 1, amountBool: true, id:16, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-1.jpg'),title:"Brown bear",price:210000, amount: 1, amountBool: true, id:17, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-2.jpg'),title:"Tiger",price:20000, amount: 1, amountBool: true, id:18, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-3.jpg'),title:"Panda",price:120000, amount: 1, amountBool: true, id:19, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-4.jpg'),title:"Pinc Bear",price:10000, amount: 1, amountBool: true, id:20, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-5.jpg'),title:"Ninza tashbaqa",price:380000, amount: 1, amountBool: true, id:21, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-4.jpg'),title:"Pinc Bear",price:10000, amount: 1, amountBool: true, id:22, heartFill: true},
        {filter:'toys',img:require('@/assets/img/toys-5.jpg'),title:"Ninza tashbaqa",price:380000, amount: 1, amountBool: true, id:23, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/televesion-1.jpg'),title:"Televesion.",price:200000, amount: 1, amountBool: true, id:24, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/televesion-5.jpg'),title:"Телевизор SAMSUNG",price:180000, amount: 1, amountBool: true, id:25, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/televesion-3.jpg'),title:"Телевизор artel 55",price:2000000, amount: 1, amountBool: true, id:26, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/televesion-4.jpg'),title:"LG Telivizor KOREA 43 dyum",price:310000, amount: 1, amountBool: true, id:27, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/plesos.jpg'),title:"LG plesoz vetman orginal",price:400000, amount: 1, amountBool: true, id:28, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/plesos-2.jpg'),title:"Plesoz  pikai 2200watt  25 litr",price:195999, amount: 1, amountBool: true, id:29, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/plesos-3.jpg'),title:"Пылесос TB916-35L",price:199000, amount: 1, amountBool: true, id:30, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/plesos-4.jpg'),title:"Pilesos",price:200000, amount: 1, amountBool: true, id:31, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/plesos-5.jpg'),title:"Pilesos Samsung SC18M21COCN",price:400000, amount: 1, amountBool: true, id:32, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/plesos-2.jpg'),title:"Pilesos Tefal UY5118",price:100000, amount: 1, amountBool: true, id:33, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/plesos.jpg'),title:"Pilesos Midea VCB43C17M",price:500000, amount: 1, amountBool: true, id:34, heartFill: true},
        {filter:'texnika',img:require('@/assets/img/plesos-4.jpg'),title:"Pilesos Scarlett SC-VC80H20",price:145000, amount: 1, amountBool: true, id:35, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/kaska.jpg'),title:"Kaska",price:20000, amount: 1, amountBool: true, id:36, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/bosch-1.jpg'),title:"Bosch drill",price:166400, amount: 1, amountBool: true, id:37, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/bolga.jpg'),title:"Bolg'a",price:20000, amount: 1, amountBool: true, id:38, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/kaska.jpg'),title:"Kaska",price:180000, amount: 1, amountBool: true, id:39, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/bosch-1.jpg'),title:"Bosch drill",price:2000000, amount: 1, amountBool: true, id:40, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/bolga.jpg'),title:"Bolg'a",price:20000, amount: 1, amountBool: true, id:41, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/kaska.jpg'),title:"Kaska",price:667000, amount: 1, amountBool: true, id:42, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/bosch-1.jpg'),title:"Bosch drill",price:889000, amount: 1, amountBool: true, id:43, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/bolga.jpg'),title:"Bolg'a",price:274000, amount: 1, amountBool: true, id:44, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/kaska.jpg'),title:"Kaska",price:234000, amount: 1, amountBool: true, id:45, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/bosch-1.jpg'),title:"Bosch drill",price:110000, amount: 1, amountBool: true, id:46, heartFill: true},
        {filter:'qurilish',img:require('@/assets/img/bolga.jpg'),title:"Bolg'a",price:20000, amount: 1, amountBool: true, id:47, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/telefon-1.jpg'),title:"Xiaomi Redmi 10A",price:2500000, amount: 1, amountBool: true, id:48, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/telefon-2.png'),title:"Smartfon Xiaomi Redmi 9C",price:3000000, amount: 1, amountBool: true, id:49, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/iphone-14.png'),title:"Apple Iphone 13 256 GB",price:6000000, amount: 1, amountBool: true, id:50, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/iphone.jpg'),title:"Apple iPhone 14 Pro Max",price:21000000, amount: 1, amountBool: true, id:51, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/iphone.png'),title:"Silikon quti iPhone 12 MagSafe",price:8000000, amount: 1, amountBool: true, id:52, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/noutbook.jpg'),title:"ASUS UX433FQ I7",price:5000000, amount: 1, amountBool: true, id:53, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/noutbook.jpg'),title:"ASUS UX433FQ I7",price:6000000, amount: 1, amountBool: true, id:54, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/noutbook-2.webp'),title:"Noutbuk HP 470 G8 8/256 GB",price:4000000, amount: 1, amountBool: true, id:55, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/noutbook-3.jpg'),title:"Noutbuk HP 255 G8 R7-5700U",price:9000000, amount: 1, amountBool: true, id:56, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/noutbook-4.png'),title:"Noutbuk HP 255 G8 R5-5500U",price:5500000, amount: 1, amountBool: true, id:57, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/noutbook-4.jpg'),title:"Noutbuk HP 15s-eq2015ne",price:7800000, amount: 1, amountBool: true, id:58, heartFill: true},
        {filter:'gadjet',img:require('@/assets/img/noutbook-5.webp'),title:"Noutbuk HP 225 G8",price:4000000, amount: 1, amountBool: true, id:59, heartFill: true},
        {filter:'sport',img:require('@/assets/img/basketbol.jpg'),title:"Basketbol to‘pi PowerGym",price:313600, amount: 1, amountBool: true, id:60, heartFill: true},
        {filter:'sport',img:require("@/assets/img/qo'lqop.jpg"),title:"Darvozabon qo‘lqoplari",price:680000, amount: 1, amountBool: true, id:61, heartFill: true},
        {filter:'sport',img:require("@/assets/img/krasofka.jpg"),title:"Green Hill PowerGym",price:200000, amount: 1, amountBool: true, id:62, heartFill: true},
        {filter:'sport',img:require("@/assets/img/turnik.jpg"),title:"Turnik GF-22UT",price:2023000, amount: 1, amountBool: true, id:63, heartFill: true},
        {filter:'sport',img:require("@/assets/img/pratain.jpg"),title:"Geyner Weider Mega Mass",price:258000, amount: 1, amountBool: true, id:64, heartFill: true},
        {filter:'sport',img:require("@/assets/img/krasofka.jpg"),title:"Green Hill PowerGym",price:200000, amount: 1, amountBool: true, id:65, heartFill: true},
        {filter:'sport',img:require("@/assets/img/turnik.jpg"),title:"Turnik GF-22UT",price:2023000, amount: 1, amountBool: true, id:66, heartFill: true},
        {filter:'sport',img:require("@/assets/img/pratain.jpg"),title:"Geyner Weider Mega Mass",price:258000, amount: 1, amountBool: true, id:67, heartFill: true},
        {filter:'sport',img:require("@/assets/img/turnik.jpg"),title:"Turnik GF-22UT",price:2023000, amount: 1, amountBool: true, id:68, heartFill: true},
        {filter:'sport',img:require("@/assets/img/pratain.jpg"),title:"Geyner Weider Mega Mass",price:258000, amount: 1, amountBool: true, id:69, heartFill: true},
        {filter:'sport',img:require("@/assets/img/volebol.jpg"),title:"Molten SoftTouch",price:150000, amount: 1, amountBool: true, id:70, heartFill: true},
        {filter:'avto',img:require("@/assets/img/kreslo.jpg"),title:"Krislo",price:200000, amount: 1, amountBool: true, id:71, heartFill: true},
        {filter:'avto',img:require("@/assets/img/chixol.jpg"),title:"Chixol",price:200000, amount: 1, amountBool: true, id:72, heartFill: true},
        {filter:'avto',img:require("@/assets/img/balon.jpg"),title:"Avtomobil shinasi Kumho",price:4150000, amount: 1, amountBool: true, id:73, heartFill: true},
        {filter:'avto',img:require("@/assets/img/balon.jpg"),title:"Avtomobil shinasi Kumho",price:4150000, amount: 1, amountBool: true, id:74, heartFill: true},
        {filter:'avto',img:require("@/assets/img/kreslo.jpg"),title:"Krislo",price:200000, amount: 1, amountBool: true, id:75, heartFill: true},
        {filter:'avto',img:require("@/assets/img/chixol.jpg"),title:"Chixol",price:200000, amount: 1, amountBool: true, id:76, heartFill: true},
        {filter:'avto',img:require("@/assets/img/balon.jpg"),title:"Avtomobil shinasi Kumho",price:4150000, amount: 1, amountBool: true, id:77, heartFill: true},
        {filter:'avto',img:require("@/assets/img/balon.jpg"),title:"Avtomobil shinasi Kumho",price:4150000, amount: 1, amountBool: true, id:78, heartFill: true},
        {filter:'avto',img:require("@/assets/img/kreslo.jpg"),title:"Krislo",price:200000, amount: 1, amountBool: true, id:79, heartFill: true},
        {filter:'avto',img:require("@/assets/img/chixol.jpg"),title:"Chixol",price:200000, amount: 1, amountBool: true, id:80, heartFill: true},
        {filter:'avto',img:require("@/assets/img/balon.jpg"),title:"Avtomobil shinasi Kumho",price:4150000, amount: 1, amountBool: true, id:81, heartFill: true},
        {filter:'avto',img:require("@/assets/img/balon.jpg"),title:"Avtomobil shinasi Kumho",price:4150000, amount: 1, amountBool: true, id:82, heartFill: true},
        
      ],
      rOne:[
        {img:require('@/assets/img/raboti__one-img2.png')},
        {img:require('@/assets/img/katalog__img8.png')},
        {img:require('@/assets/img/katalog__img5.png')},
        {img:require('@/assets/img/katalog__img1.png')},
        {img:require('@/assets/img/katalog__img4.png')},
        {img:require('@/assets/img/katalog__img8.png')},
        {img:require('@/assets/img/katalog__img1.png')},
        {img:require('@/assets/img/katalog__img2.png')}
      ],
      rTwo:[
        {city:'Tashkent. Chilanzar', bool: 'chilanzar'},
        {city:'Tashkent. Olmazor', bool: 'olmazor'},
        {city:'Tashkent. Sergili', bool: 'sergili'},
        {city:'Tashkent. Yunusabod', bool: 'yunusabod'}
      ]
    }
  },
  methods: {
    cartList(cartObj){
      this.cart = cartObj.bool
      this.OneFilter = cartObj.filter
    },
    cartObj(cartObj){
      this.cart = cartObj.bool
    },
    addCart(cartObj){
      if (cartObj.price > 0) {
        this.shop.push(cartObj)
      }
    },
    addNote(cartObj){
      if (cartObj.price > 0) {
        this.shop.push(cartObj)
      }
    },
    tPlus(tCart){
      this.tOne.forEach(tavar => {
        this.shop.forEach((cart) => {
          if (tCart.id == cart.id) {
            if (tCart.id == tavar.id) {
              cart.amount = tCart.amount
            }
            
          }
        });
      });
    },
    tMinus(tCart){
      this.shop.forEach((cart) => {
        if (tCart.id == cart.id) {
          cart.amount = tCart.amount
        }
      });
    },
    delCart(cartObj){
      this.shop.forEach((cart,index) => {
        if (cartObj == cart.id) {
          this.shop.splice(index,1) 
        }
      });
    },
    changeCart(changeObj){
      this.tOne.forEach((cart) => {
          if (changeObj.id == cart.id) {
            if (changeObj.change == '-') {
              if (cart.amount > 1) {
                cart.amount--
              }
              else{
                cart.amount = 1
              }
            }
            else{
              cart.amount++
            }
            this.shop.forEach(cart => {
                if (cart.id == changeObj.id) {
                    if (changeObj.change == '-') {
                        if (cart.amount > 1) {
                            cart.amount--
                        }
                        else{
                            cart.amount = 1
                        }
                    }
                    else{
                        cart.amount++
                    }
                }
            });
          }
      });
    },
    delCard(cardObj){
      this.tOne.forEach(tavar => {
        if (cardObj == tavar.id) {
          tavar.amount = 1
          tavar.amountBool = true
        }
      });
    },
    addHeart(heartObj){
      this.heart.push(heartObj)
      this.tOne.forEach(tavar => {
        if (heartObj.id == tavar.id) {
          tavar.heartFill = false
        }
      });
    },
    heartFill(heartId){
      this.heart.forEach((heart,i) => {
        if (heart.id == heartId) {
          this.heart.splice(i,1)
          this.tOne.forEach(tavar => {
            if (heartId == tavar.id) {
              tavar.heartFill = true
            }
          });
        }
      });
    },
    delHeart(heartId){
      this.heart.forEach((heart,i) => {
        if (heartId == heart.id) {
          this.heart.splice(i,1)
          this.tOne.forEach(tavar => {
            if (heartId == tavar.id) {
              tavar.heartFill = true
            }
          });
        }
      });
    },
    modalInfo(value){
      this.modalBool = value.bool
      this.modalObj = value.obj
    }
  },
  computed: {
    icon() {
      if (this.heart.length > 0) {
        return true
      }
    },
    iconShop(){
      if (this.shop.length > 0) {
        return true
      }
    },
    cartFilter(){
      let cart = this.tOne
      // let type = 
    }
  },
  mounted() {
    let introOne = document.querySelector('.introOne');
    window.addEventListener("scroll", (el)=>{
        if (window.scrollY > 170) {
            introOne.style = `margin-top: ${this.navH}px;`
        }else{
            introOne.style = `margin-top: 0;`
        }
    });
  },
}
</script>

<style lang="scss">
.modal-enter-active,
.modal-leave-active {
  transition: all 0.5s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
  /* transform: translateY(30px); */
  transform: scale(0.8);
}
</style>
